module.exports = __webpack_public_path__ + "static/img/bg-jiaolianyuan.61591bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cha/bg-jiaolianyuan.png
// module id = 940
// module chunks = 0